import Col from "@visa/vds/col";
import Grid from "@visa/vds/grid";
import Row from "@visa/vds/row";
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import MCSSpace from "components/MCSSpace";
import { useAuthContextUser } from "context/AuthContext";
import { TermsOfUseHelper } from "_helpers/TermsOfUseHelper";

function TermsOfUsePage() {
  const user = useAuthContextUser();
  const { pathname } = useLocation();
  const pathnames = pathname.split("/");  
  const [htmlFileString, setHtmlFileString] = useState(null);

  async function fetchHtml(fileName) {
    const response = await fetch(fileName)
    let htmlString = await response.text()
    setHtmlFileString(htmlString)
  }

  useEffect(() => {
    let touPath = TermsOfUseHelper.GetTouPath(user, pathnames);
    let touHtmlPath = process.env.PUBLIC_URL + touPath;
    console.log('Tou Html Path: ', touHtmlPath);
    fetchHtml(touHtmlPath);
  }, [user, pathnames]);

  useEffect(() => {
    const hashtags = document.getElementsByClassName("MsoEndnoteReference");
    for (let i = 0; i < hashtags.length; i++) {
      let anchortag = hashtags[i].closest("a");
      if (
        anchortag.hash !== "" &&
        anchortag.href.indexOf(window.location.pathname) === -1
      )
        anchortag.href = window.location.pathname + anchortag.hash;
    }
  }, [htmlFileString]);   

  return (
    <Grid>
      <Row>
        <Col>
          <div dangerouslySetInnerHTML={{ __html: htmlFileString }}></div>
        </Col>
      </Row>
      <MCSSpace />
    </Grid>
  );
}
export default TermsOfUsePage;
